import { toEn } from "./digits";

/**
 * Copy text to the clipboard, normalising Persian digits to Latin first.
 *
 * `navigator.clipboard` is undefined on non-secure origins (testing over a LAN IP, for
 * instance), so fall back to the execCommand path rather than silently doing nothing.
 *
 * @returns {Promise<boolean>} whether the copy succeeded.
 */
export function copyText(raw) {
  const text = toEn(raw || "").replace(/\s+/g, "");
  if (!text) return Promise.resolve(false);

  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard
      .writeText(text)
      .then(() => true)
      .catch(() => legacyCopy(text));
  }
  return Promise.resolve(legacyCopy(text));
}

function legacyCopy(text) {
  const field = document.createElement("textarea");
  field.value = text;
  field.setAttribute("readonly", "");
  field.style.position = "absolute";
  field.style.left = "-9999px";
  document.body.appendChild(field);
  field.select();
  let ok = false;
  try {
    ok = document.execCommand("copy");
  } catch (e) {
    ok = false;
  }
  document.body.removeChild(field);
  return ok;
}
